import React, { useState } from 'react'
import { Box, Button, Divider, Typography } from '@mui/material'
import SingleLineItem from './SingleLineItem'

import { lineItemsStyles } from '../../../../styles/classes/MobilePreviewClasses'

import { store } from '../../../../store'
import { lineItemFields, rateTypeOptions } from '../../../../lib/Constants'
import { useTranslation } from 'react-i18next'
import { inputTypeValueTransformer } from '../../../../utils/mobilePreview'

const emptyItem = {}
for (const [, value] of Object.entries(lineItemFields)) {
  emptyItem[value] = ''
}
const LineItems = ({
  lineItemsList,
  onChangeValue,
  disabled,
  question,
  helpfulHint,
  isMandatory,
  isPreviewMode
}) => {
  const { t } = useTranslation()
  const rateType = question?.rate
  const { classes } = lineItemsStyles()
  const itemsLimit = question.items_limit ?? 1
  const enableAmounts = question?.total_amount_due
  const [lineItems, setLineItems] = useState(
    lineItemsList ?? [{ ...emptyItem }]
  )
  const typePicklistValues =
    store.getState().auth?.typeDetails?.picklistValues ?? []

  // eslint-disable-next-line array-callback-return
  let rateOptions = typePicklistValues.map(item => {
    if (item.active) {
      return item.label
    }
  })

  if (rateType === rateTypeOptions.ENABLE_CUSTOM_OPTIONS) {
    rateOptions = question?.options ?? []
  }

  const addLineItemHandler = () => {
    setLineItems(prevLineItems => {
      const newItems = [...prevLineItems, { ...emptyItem }]
      return newItems
    })
    // update all here
    const prevLineItems = JSON.parse(JSON.stringify(lineItems))
    const newLineItems = [...prevLineItems, { ...emptyItem }]
    if (onChangeValue) onChangeValue(newLineItems)
  }

  const removeLineItemHandler = index => {
    setLineItems(prevItems => {
      const newItems = [...prevItems]
      newItems.splice(index, 1)
      return newItems
    })
    // update all here
    const prevLineItems = JSON.parse(JSON.stringify(lineItems))
    const newLineItems = [...prevLineItems, { ...emptyItem }]
    if (onChangeValue) onChangeValue(newLineItems)
  }

  const calculateLineItemTotal = lineItem => {
    const amount = +lineItem?.amount ?? 0
    const quantity = +lineItem?.quantity ?? 0
    const tax = +lineItem?.tax ?? 0

    const total = amount * quantity
    const totalWithTax = total + (total * tax) / 100

    return totalWithTax
  }

  const updateFieldsHandler = (index, field, value) => {
    setLineItems(prevItems => {
      let modValue = value
      const calculationCondition =
        field === lineItemFields.QUANTITY ||
        field === lineItemFields.AMOUNT ||
        field === lineItemFields.TAX
      if (field === lineItemFields.TAX && !!modValue && +modValue > 100) {
        modValue = '100'
      }
      if (calculationCondition) {
        modValue = inputTypeValueTransformer('numeric_only', modValue)
      }
      const newItems = [...prevItems]
      newItems[index][field] = modValue
      if (calculationCondition) {
        const calculatedTotal = calculateLineItemTotal(
          newItems[index]
        ).toString()
        newItems[index][lineItemFields.TOTAL] = calculatedTotal
      }
      return newItems
    })
    // if these two update from here the reset use onBlur as they are text fields
    if (field === lineItemFields.LABOR_TYPE || field === lineItemFields.RATE) {
      const prevItems = JSON.parse(JSON.stringify(lineItems))
      let modValue = value
      const calculationCondition =
        field === lineItemFields.QUANTITY ||
        field === lineItemFields.AMOUNT ||
        field === lineItemFields.TAX
      if (field === lineItemFields.TAX && !!modValue && +modValue > 100) {
        modValue = '100'
      }

      if (calculationCondition) {
        modValue = inputTypeValueTransformer('numeric_only', modValue)
      }
      const newItems = [...prevItems]
      newItems[index][field] = modValue
      if (calculationCondition) {
        const calculatedTotal = calculateLineItemTotal(newItems[index])
        newItems[index][lineItemFields.TOTAL] = calculatedTotal
      }
      onChangeValue(newItems)
    }
  }

  const AddButton = () => {
    return (
      <Button
        className={classes.addButton}
        variant="outlined"
        size="small"
        onClick={addLineItemHandler}
        disabled={disabled}
      >
        + {t('mobile_preview.line_item.labor')}
      </Button>
    )
  }

  function getSubtotal () {
    let subTotal = 0
    if (!lineItems) return (0).toFixed(2)
    for (const item of lineItems) {
      if (item.total) {
        subTotal += +item.total
      }
    }
    return subTotal?.toFixed(2)
  }

  const subTotalValue = getSubtotal()

  const DashedDivider = () => {
    return <Box className={classes.dashedDividerContainer}>
        <hr className={classes.customDivider} />
      </Box>
  }

  function SubTotalComponent () {
    if (isPreviewMode) {
      return (
        <Box>
          <Typography className={classes.previewSubtotalValue}>
            $ {subTotalValue}
          </Typography>
          <Divider component="li" className={classes.divider} />
        </Box>
      )
    }
    const str = '-'
    return (
      <Box className={classes.subtotalContainer}>
        <Typography className={classes.subTotalValue}>
          {str.repeat(7)} {subTotalValue} {str.repeat(7)}
        </Typography>
        <Typography className={classes.subTotalLabel}>
          {t('subtotal')}
        </Typography>
      </Box>
    )
  }

  let BottomCmp = null
  if (enableAmounts && !isPreviewMode) {
    BottomCmp = <SubTotalComponent />
  }

  return (
    <Box className={[classes.container, isPreviewMode && classes.shadow]}>
      {isPreviewMode && <SubTotalComponent />}
      {lineItems?.map((item, index) => {
        return (
          <Box key={index}>
            <SingleLineItem
              updateCallback={() => {
                const newLineItems = JSON.parse(JSON.stringify(lineItems))
                onChangeValue(newLineItems)
              }}
              rateOptions={rateOptions}
              itemSettings={question}
              isMandatory={isMandatory}
              helpfulHint={helpfulHint}
              index={index}
              item={item}
              onChange={updateFieldsHandler}
              onRemove={removeLineItemHandler}
              disabled={disabled}
            />
            {index !== lineItems.length - 1 && <DashedDivider />}
          </Box>
        )
      })}
      {BottomCmp}
      <Box display="flex" justifyContent="center" paddingTop={'20px'}>
        {lineItems.length < itemsLimit && <AddButton />}
      </Box>
      <Divider component="li" className={classes.divider} />
    </Box>
  )
}

export default LineItems
